// extracted by extract-css-chunks-webpack-plugin
module.exports = {"headingWrapper":"_3HAuzl","heading":"xTVZhF","status":"_1GBHzm","icon":"_3QPGZM","description":"_324sea","bottomDescription":"_3qeeJI","modal":"_22Ud1m","open":"_1YpVcC"};